import url from "url/index";
import { SEO } from "utils/helmet/components/SEO";
import InviteFriendContainer from "../../../../containers/organisms/InviteFirendContainer";

import "./styles.sass";

const InviteFriendPage = () => {
  return (
    <>
      <SEO
        pathname={`/${url.config.profile.root}/${url.config.profile.inviteFriend}`}
      />
      <InviteFriendContainer />
    </>
  );
};

export default InviteFriendPage;
